<template>
  <v-container fluid>
    <v-row>
      <v-col cols="8" align="start" class="start text size-large weight-bold font-alt pa-4">Visualisez et organisez vos
        campagnes</v-col>
      <v-col cols="4" align="end">
        <v-btn class="theme-btn shape-rounded filled-purple glow drawer-button" @click="goToCreateScenario('affluence')">
          Créer une campagne
        </v-btn>
      </v-col>
    </v-row>

    <v-row class="pa-4 background-white-light">
      <!-- SEARCH BAR -->

      <!-- <v-col cols="12" class="mb-4">
        <v-text-field v-model="searchFilter" rounded solo
          label="Rechercher une campagne, une date, un horaire, un mot ou phrase d'un message" hide-details
          append-icon="search" elevation="0">
        </v-text-field>
      </v-col> -->

      <!-- LEFT WING -->

      <v-col cols="12" lg="3" class="colored-bg pa-3 mt-3">
        <v-row class="px-3 my-4">
          <v-col cols="6" align="start">
            <strong style="font-size: 22px">Mes campagnes</strong>
          </v-col>
          <!-- <v-col cols="6" align="end">
            <v-menu open-on-hover bottom offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn single-line style="border: 3px solid #ffc306" hide-details rounded v-bind="attrs" v-on="on" elevation="0">
                  <strong>Filtrer</strong>
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(item, index) in items" :key="index">
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col> -->
        </v-row>
        <v-row>
          <v-col cols="12">
            <scenario-card
              v-for="scenario in scenarios"
              :key="`scenario-${scenario.id}`"
              :scenario="scenario"
              @trigger-update-card="triggerUpdateCard(scenario)"
              @sendNow="sendNow(scenario.id)"
            />
          </v-col>
        </v-row>
      </v-col>

      <!-- RIGHT WING -->

      <v-col cols="12" lg="9">
        <v-row justify="space-around" class="background-primary mx-1 top-cards-bg pa-5">

          <!-- CALENDAR -->

          <v-col cols="6">
            <h3 class="pl-4">
              <strong>Planning de vos campagnes actives</strong>
            </h3>
          </v-col>

          <v-col cols="6" v-if="$refs.calendar" style="justify-content: flex-end;display: flex;">
            <strong class="pr-4" style="text-transform: uppercase">{{
              $refs.calendar.title
            }}</strong>
            <v-btn @click="$refs.calendar.prev()">
              <v-icon> keyboard_arrow_left </v-icon>
            </v-btn>
            <v-btn
              @click="setToday"
            >
              Aujourd'hui
            </v-btn>
            <v-btn class="mr-4" @click="$refs.calendar.next()">
              <v-icon> keyboard_arrow_right </v-icon>
            </v-btn>
            <v-menu
                  bottom
                  right
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                    >
                      <span>{{ typeToLabel[type] }}</span>
                      <v-icon right>
                        mdi-menu-down
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="type = 'day'">
                      <v-list-item-title>Day</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="type = 'week'">
                      <v-list-item-title>Week</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="type = 'month'">
                      <v-list-item-title>Month</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="type = '4day'">
                      <v-list-item-title>4 days</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
          </v-col>
          

          <v-col cols="12">
            
            <v-sheet height="600" style="border-radius: 30px; overflow: hidden">
              <v-calendar
                v-model="now"
                ref="calendar"
                style="border-radius: 30px; overflow: hidden;"
                color="#ffc306"
                :type="type"
                :events="displayEvents"
                :event-overlap-mode="mode"
                @click:more="viewDay"
                @click:event="showEvent"></v-calendar>
              <v-menu v-model="selectedOpen" max-width="350" :close-on-content-click="false" :activator="selectedElement">
                <v-card color="" flat>
                  <v-toolbar :color="selectedEvent.color" dark>
                    <v-btn icon>
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon>
                      <v-icon>mdi-heart</v-icon>
                    </v-btn>
                    <v-btn icon>
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text>
                    Commence le
                    <span v-html="selectedEvent.start"></span>
                  </v-card-text>
                  <!-- <v-card-text>
                    Fini le
                    <span v-html="selectedEvent.end"></span>
                  </v-card-text> -->
                  <v-card-actions>
                    <v-btn text color="secondary" @click="selectedOpen = false">
                      Cancel
                    </v-btn>
                    <!-- <v-spacer></v-spacer>
                    <v-btn text color="secondary" @click="triggerUpdateCard(selectedEvent)">
                      Ouvrir
                    </v-btn> -->
                  </v-card-actions>
                </v-card>
              </v-menu>
            </v-sheet>
            <!-- style="border-radius: 60px" -->
          </v-col>
        </v-row>
        <ScenarioDetailsCard class="mt-8" v-if="displayCard" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import API from '../../../api/callApi';
import ScenarioCard from './components/scenario-card.vue';
import ScenarioDetailsCard from './components/scenario-details-card.vue';
export default {
  components: {
    ScenarioCard,
    ScenarioDetailsCard,
  },

  data() {
    return {
      displayCard: false,
      searchFilter: '',
      items: [{ title: 'Breakfast' }, { title: 'Lunch' }, { title: 'Dinner' }],
      type: 'month',
      typeToLabel: {
        month: 'Mois',
        week: 'Semaine',
        day: 'Jour',
        '4day': '4 Jours',
      },
      now: new Date(),
      calendarView: [
        { text: 'Semaine', value: 'week' },
        { text: 'Mois', value: 'month' },
      ],
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      mode: 'stack',
    };
  },

  created() {
    this.$store.dispatch('scenarios/scenariosData')
  },

  methods: {
    sendNow(scenarioId) {
      this.$store.commit(
        'ui/cloader',
        {
          display: true,
          label: 'Envoi en cours',
        },
        { root: true },
      );
      API.sendNow(scenarioId, this.$store);
    },
    triggerUpdateCard(scenario) {
      this.$emit('trigger-update-card');
    },
    goToCreateScenario(type) {
      this.$router
        .push({
          name: 'CreateWorkflow',
          params: null
        })
    },
    getEventColor(event) {
      return event.color;
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true)),
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    viewDay ({ date }) {
      this.now = date
      this.type = 'day'
    },
    setToday () {
        this.now = ''
      },
      prev () {
        this.$refs.calendar.prev()
      },
      next () {
        this.$refs.calendar.next()
      },
  },

  computed: {
    scenarios() {
      return this.$store.state.scenarios.scenarios
    },
    displayEvents() {
      const events = [];

      for (let scenario of this.$store.state.scenarios.scenarios) {
        let color = 'grey';
        if (scenario.is_active && scenario.segments.length > 0) {
          color = scenario.segments[0].color
        }
        events.push({
          start: new Date(scenario.start_datetime),
          end: new Date(scenario.end_datetime),
          timed: false,
          name: scenario.name,
          color: color,
        })
      }
      return events;
    },
  },
};
</script>

<style lang="scss">
.scenario-start-date {
  font-size: 10px;
  font-weight: 500;
  color: #585861;
  padding-left: 18px;
}

.text-card {
  font-size: 16px;
  color: #585861;
}

.v-select__selection,
.v-select__selection--comma,
.v-select.v-text-field input {
  color: $color-primary !important;
}

.colored-bg {
  background-color: white;
  border-radius: 25px;
}

.fix {
  overflow-wrap: anywhere;
  word-wrap: break-word;
  word-break: normal;
  hyphens: auto;
}

.border {
  border: solid 2px black;
}

.border1 {
  border: solid 4px red;
}

.cards {
  border-radius: 25px !important;
}

.title-wrap {
  word-break: break-word;
}

.top-btn {
  color: white !important;
}

.top-cards-bg {
  overflow: hidden;
  margin-top: 2px;
  border-radius: 25px !important;
  position: relative;
}

.v-calendar-weekly__head {
  font-size: 150px !important;
  font-weight: bold;
  border-bottom: 1px #e0e0e0 solid;
  height: 50px;
  color: $color-white !important;
  background-color: $color-secondary;
  align-items: center;
display: flex;
justify-content: center;
  .v-outside {
    background-color: $color-secondary !important;
    color: $color-white !important;
  }
}
.v-calendar-weekly__head-weekday.v-future{
  color: $color-white !important;
}

.v-outside {
  //background-color: white !important;
}
</style>
